var currentPage = "design";
$j = jQuery.noConflict();
var approveData = null;
var renderData = null;
var saveData = null;
var currentStateId = "";
var previewImage = "";
var imageMaxHeight = 500;
var option_id = 0;
var option_value_id = 0;
let product = null;
let mockupPreviewsImages = [];
var configJson = window.configJson || {};
let configPrice = {};
let total_price = 0;
let initOptionsProcess = false;
let item_options = {};
var urlParams = new URLSearchParams(window.location.search);
var data = getUrlParamRaw("data");
let is1color = false;

if (urlParams.get("step") == "configurator_options") {
  document
    .querySelector("w-product-template:not(.configurator-options)")
    ?.closest(".product-main")
    ?.remove();
  document.querySelector(".cc-featured-collection")?.remove();
} else if (urlParams.get("step") == "" || urlParams.get("step") == null) {
  document
    .querySelector("w-product-template.configurator-options")
    ?.closest(".product-main")
    ?.remove();
}

if (urlParams.get("step") == "configurator_options") {
  document.querySelector(".loader__container").classList.add("visible");
  document.querySelector("media-gallery").classList.add("opacity");
}

// Filter papers by profil - only on normal page, not on options page
// On options page, papers are already filtered by JavaScript in w-configurator-options.liquid
if (urlParams.get("step") !== "configurator_options") {
  document.querySelectorAll("[data-profil]").forEach((item) => {
    let profils = item.dataset.profil.split(",");
    if (profils.includes(configurator.ref_profil)) {
      item.style.display = "block";
    } else {
      item.style.display = "none";
    }
  });
}

(function initFancy() {
  if (typeof Fancybox === "undefined") {
    return setTimeout(function () {
      initFancy();
    }, 500);
  }
  Fancybox.bind("[data-fancybox]", {
    // Your custom options
  });
})();

function getCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == " ") c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

function setCookie(name, value, days) {
  var expires = "";
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

// Check if the url params contains view=configurator_options and setup configJson with cookies

configJson = Object.assign({}, metafields_products, window.configJson || {});
window.configJson = configJson;

// get cookie ref_id
let CONFIGURATOR = getUrlConfig();

if (!CONFIGURATOR) {
  CONFIGURATOR = {};
  const savedDefaults = window.profil_defaults?.[configurator.ref_profil];

  CONFIGURATOR.current_paper = savedDefaults?.paper
    || document.querySelector('[data-id="papier"]')?.dataset.value;
  CONFIGURATOR.current_enveloppe = savedDefaults?.envelope
    || document.querySelector('[data-id="enveloppe"]')?.dataset.value;
  CONFIGURATOR.current_ribbon = savedDefaults?.ribbon
    || document.querySelector('[data-id="ruban"]')?.dataset.value;
  CONFIGURATOR.current_cut = savedDefaults?.cut || null;

  const urlQuantity = urlParams.get("quantity");
  CONFIGURATOR.quantity = urlQuantity ? parseInt(urlQuantity) : 1;

  CONFIGURATOR.format_imposition = configurator.format_imposition;
  CONFIGURATOR.ref_profil = configurator.ref_profil;
}

// The cart edit link (state=update) carries the current quantity as a query
// param, kept in sync with the latest cart quantity-update, whereas
// data.quantity is frozen at add-to-cart time. Let the query param win so the
// price and the quantity selector reflect the real cart quantity.
const editQuantity = urlParams.get("quantity");
if (editQuantity) {
  CONFIGURATOR.quantity = parseInt(editQuantity);
}

// Expose CONFIGURATOR to window for access by other scripts (w-configurator-cart.js)
window.CONFIGURATOR = CONFIGURATOR;

let profil = urlParams.get("ref_profil");

let preview_color = null;

let p_obj = null;

if (CONFIGURATOR.ref_profil) {
  profil = CONFIGURATOR.ref_profil;
}

if (profil) {
  for (let i = 0; i < configJson.profils.length; i++) {
    if (
      configJson.profils[i].ref_profil.toLowerCase().trim() ==
      profil.toLowerCase().trim()
    ) {
      CONFIGURATOR.ref_profil = configJson.profils[i].ref_profil;
      p_obj = configJson.profils[i];
      CONFIGURATOR.format_imposition = configJson.profils[i].format_imposition;
      preview_color = configJson.profils[i].preview_color;

      if (
        configJson.profils[i].colors &&
        configJson.profils[i].colors.length > 0
      ) {
        // assign preview_color with profils[i].colors[0] first key value
        console.log(configJson.profils[i]);
        preview_color = configJson.profils[i].colors[0].hexa;
        is1color = true;
      }

      if (
        configJson.profils[i].textures &&
        configJson.profils[i].textures.length > 0 &&
        !CONFIGURATOR.ref_texture
      ) {
        CONFIGURATOR.ref_texture = configJson.profils[i].textures[0].filename;
      }
    }
  }
  if (!p_obj) {
    console.error(
      "[configurateur] Aucun profil ne correspond à",
      profil,
      "— profils disponibles :",
      (configJson.profils || []).map((p) => p && p.ref_profil)
    );
  }
}

let current_cut = CONFIGURATOR.current_cut ? CONFIGURATOR.current_cut : "00";
let imposition_format = CONFIGURATOR.format_imposition.toLowerCase();

let index_cut = configJson.format.ref_cut.indexOf("CUT" + current_cut);
let current_imposition = configJson.current_imposition
  ? configJson.current_imposition
  : configJson.format[`imposition_${imposition_format}`][index_cut];

CONFIGURATOR.current_cut = current_cut;
CONFIGURATOR.current_imposition = current_imposition;

configJson.item_options = {};

/**
 * Initialize the editor
 */
var defaultEditorConfig = {
  // theme: "1001Cartes",
  defaultLanguage: "fr",
  preloader: {
    firstTimeMessage:
      "Chargement de l'application et préparation de votre produit en cours...",
    errorMessage: "Impossible de charger le produit!",
    enabled: false,
  },
  canvas: {
    containerColor: "#FFFFFF",
    printZone: {
      trim: { color: "rgba(0,0,0,0)" },
    },
  },
  rendering: {
    proofImageSafetyLinesEnabled: false,
    proofImageSpineAndFoldingLinesEnabled: false,
    proofImageFileFormat: p_obj.preview_mockup_file_extension,
  },
  productThemes: productThemes,
};

console.log(defaultEditorConfig);
var editor;
var mockups = {};

async function initUser() {
  // NEW VERSION

  const user_logged = customer_id && customer_id != "" ? true : false;
  let session = getCookie("userId");

  if (user_logged) {
    let token = null;

    // get user token
    token = await getTokenId(customer_id);

    if (!token) {
      // create new token
      token = await createTokenId(customer_id);
    }

    defaultEditorConfig.tokenId = token;
    defaultEditorConfig.userId = customer_id.toString();
  } else {
    // get user session cookie

    if (session) {
      // get token from session
      let token = await getTokenId(session);
      if (token) {
        defaultEditorConfig.tokenId = token;
      } else {
        // create new token
        let token = await createTokenId(session);
        defaultEditorConfig.tokenId = token;
      }
      defaultEditorConfig.userId = session;
    } else {
      // create new session
      let session =
        Math.random().toString(36).substring(2, 10) +
        Math.random().toString(36).substring(2, 10);
      setCookie("userId", session);
      let token = await createTokenId(session);
      defaultEditorConfig.tokenId = token;
      defaultEditorConfig.userId = session;
    }
  }
}

async function getTokenId(id) {
  var token = (
    await (
      await fetch(
        window.SERVICE_URLS.de + "/api/Auth/Users/" + id + "/Tokens",

        {
          method: "GET",
          headers: { "X-CustomersCanvasAPIKey": "128ed921f31f122aa8129f291d" },
        }
      )
    ).json()
  ).tokens[0]?.tokenId;

  return token;
}

async function createTokenId(id) {
  var token = (
    await (
      await fetch(
        window.SERVICE_URLS.de + "/api/Auth/Users/" + id + "/Tokens",

        {
          method: "POST",
          headers: { "X-CustomersCanvasAPIKey": "128ed921f31f122aa8129f291d" },
        }
      )
    ).json()
  ).tokenId;

  return token;
}

// Renamed from initProduct to avoid clashing with the function of the same
// name in w-configurateur.js (loaded later in body, was overriding this one
// → drawer listeners were never attached → cut/paper clicks did nothing).
function initProductListeners(product) {
  // check if the url params contains view=configurator_options and inject previewMockup
  var view = urlParams.get("step");
  // Skip configurator init for products without configurator drawers (non-carterie types)
  if (!document.querySelector("product-drawer-decoupe, product-drawer-papier, product-drawer-quantite")) {
    return;
  }
  document
    .querySelector(
      '.drawer-list__item--profil[data-value="' + CONFIGURATOR.ref_profil + '"]'
    )
    ?.classList.add("actif");
  if (view === "configurator_options") {
    injectMockupPreviewCookies();
  }

  /**
   * Event listener for cut selection
   */
  let selectCut = document.querySelector("product-drawer-decoupe .drawer-list");
  if (selectCut) selectCut.querySelectorAll("[data-value]").forEach((elem) => {
    elem.addEventListener("click", function (e) {
      selectCut.querySelectorAll("[data-value]").forEach((elem) => {
        elem.classList.remove("actif");
      });
      let value = elem.dataset.value;
      current_cut = value;
      CONFIGURATOR.current_cut = value;

      CONFIGURATOR.current_imposition =
        configJson.format[`imposition_${imposition_format}`][
          configJson.format.ref_cut.indexOf("CUT" + current_cut)
        ];

      elem.classList.add("actif");

      // Save selection scoped to current product
      setCookie(
        "configurator_selections",
        JSON.stringify({
          product_handle: configJson.product ? configJson.product.handle : '',
          current_paper:
            CONFIGURATOR.current_paper || configJson.papers.file_paper[0],
          current_cut: value,
        }),
        1
      );

      let cut_title = elem.dataset.cutTitle;

      document.querySelector(".decoupe-value").innerHTML = cut_title;

      let price = parseInt(elem.dataset.price);
      document.querySelector(
        ".drawer-button[data-id='decoupe']"
      ).dataset.price = price;

      // e.isTrusted is true for real user clicks, false for programmatic
      // .click() (used by initDefaultOptions). Always apply for real clicks
      // — initOptionsProcess can be stuck true if init is interrupted.
      if (e.isTrusted || !initOptionsProcess) {
        applyOption();
      }
    });
  });

  /***
   * Add colors to drawer color
   */
  let selectColor = document.querySelector(
    "product-drawer-couleur .drawer--list"
  );
  if (
    selectColor &&
    configJson.themes_colors &&
    configJson.themes_colors.hasOwnProperty("ref_color")
  ) {
    for (let i = 0; i < configJson.themes_colors.ref_color.length; i++) {
      let option = document.createElement("div");
      option.setAttribute(
        "data-color-name",
        configJson.themes_colors.name_color[i]
      );
      option.dataset.value = configJson.themes_colors.ref_color[i];
      let bubble = document.createElement("span");
      bubble.style.backgroundColor = configJson.themes_colors.hexa_color[i];
      option.textContent = configJson.themes_colors.name_color[i];
      option.appendChild(bubble);
      selectColor.appendChild(option);
    }
  }

  /***
   * Event listener for color selection
   */
  if (selectColor) selectColor.querySelectorAll("div").forEach((elem) => {
    elem.addEventListener("click", function (e) {
      selectColor.querySelectorAll("div").forEach((elem) => {
        elem.classList.remove("active");
      });
      let value = elem.dataset.value;

      document.querySelector(".couleur-value").textContent = elem.textContent;
      elem.classList.add("active");
      document.querySelector(
        '.drawer-button[data-id="couleur"] .couleur-value'
      ).innerHTML = elem.dataset.colorName;
      editor.applyProductTheme(value);
      applyOption();
      if (!initOptionsProcess)
        document.querySelector("w-product-template").closeDrawer();
      CONFIGURATOR.current_color = value;
    });
  });

  /***
   * Add colors to drawer color
   */
  let selectTexture = document.querySelector(
    "product-drawer-texture .drawer--list"
  );

  /***
   * Event listener for texture selection
   */
  if (selectTexture) selectTexture.querySelectorAll("[data-texture-title]").forEach((elem) => {
    elem.addEventListener("click", function (e) {
      selectTexture.querySelectorAll("[data-texture-title]").forEach((elem) => {
        elem.classList.remove("actif");
      });
      let value = elem.dataset.value;

      document.querySelector(".texture-value").textContent = elem.textContent;
      elem.classList.add("actif");
      document.querySelector(
        '.drawer-button[data-id="texture"] .texture-value'
      ).innerHTML = elem.dataset.textureName;
      CONFIGURATOR.ref_texture = value;
      applyOption();
      if (!initOptionsProcess)
        document.querySelector("w-product-template").closeDrawer();
    });
  });

  /**
   * Event listener for quantity
   */

  let selectQuantityItems = document.querySelectorAll(
    '.drawer-list__item[data-variant-option="quantity"]'
  );

  selectQuantityItems.forEach((elem) => {
    elem.addEventListener("click", function (e) {
      selectQuantityItems.forEach((elem) => {
        elem.classList.remove("actif");
      });

      CONFIGURATOR.quantity = parseInt(elem.dataset.quantityValue);
      elem.classList.add("actif");
      document.querySelector(
        '[data-id="quantite"] .quantite-value'
      ).textContent = elem.dataset.quantityLabel;

      let price = parseInt(elem.dataset.price);
      document.querySelector('[data-id="quantite"]').dataset.price = price;
      document.querySelector('[data-id="quantite"]').dataset.quantity =
        elem.dataset.quantityValue;

      document.querySelector("w-product-template").closeDrawer();
      client_has_selected_qty = true;
      document.querySelectorAll(".price-conf").forEach((elem) => {
        if (elem.closest("[data-cut-title]")) {
          elem.setAttribute(
            "style",
            "display: block !important;font-weight: 400"
          );
        } else {
          elem.setAttribute("style", "display: inline !important");
        }
      });

      const activeCut = document.querySelector("[data-cut-title].actif");
      if (activeCut) {
        document.querySelector(".decoupe-value").innerHTML = activeCut.dataset.cutTitle;
      }

      const activePaper = document.querySelector("[data-paper-title].actif");
      if (activePaper) {
        const paperValueElem = document.querySelector(".papier-value");
        if (paperValueElem) {
          paperValueElem.innerHTML = activePaper.dataset.paperTitle;
        }
      }

      const activeEnveloppe = document.querySelector("[data-enveloppe-title].actif");
      if (activeEnveloppe) {
        document.querySelector(".enveloppe-value").innerHTML = activeEnveloppe.dataset.enveloppeTitle;
      }

      const activeRuban = document.querySelector("[data-ruban-title].actif");
      if (activeRuban) {
        document.querySelector(".ruban-value").innerHTML = activeRuban.dataset.rubanTitle;
      }

      initPrice();

      setTimeout(updateOptionQuantityPrice, 400);
    });
  });

  /**
   * Event listener for paper selection
   */
  let selectPaper = document.querySelector(
    "product-drawer-papier .drawer--list"
  );

  if (selectPaper) {
    selectPaper.querySelectorAll("[data-value]").forEach((elem) => {
    elem.addEventListener("click", function (e) {
      console.log("Paper clicked:", elem);
      console.log("data-value:", elem.dataset.value);
      console.log("data-paper-title:", elem.dataset.paperTitle);
      console.log("data-price:", elem.dataset.price);

      selectPaper.querySelectorAll("[data-value]").forEach((elem) => {
        elem.classList.remove("actif");
      });

      let value = elem.dataset.value;
      CONFIGURATOR.current_paper = value;

      // Mettre à jour aussi configJson si disponible
      if (typeof configJson !== "undefined") {
        configJson.current_paper = window.configJson.current_paper = value;
      }

      // Save selection scoped to current product
      setCookie(
        "configurator_selections",
        JSON.stringify({
          product_handle: configJson.product ? configJson.product.handle : '',
          current_paper: value,
          current_cut: CONFIGURATOR.current_cut || 0,
        }),
        1
      );

      elem.classList.add("actif");

      let paper_title = elem.dataset.paperTitle || "Papier non défini";
      console.log("Setting paper_title:", paper_title);
      const paperValueElem = document.querySelector(".papier-value");
      if (paperValueElem) {
        paperValueElem.innerHTML = paper_title;
      }

      let price = parseInt(elem.dataset.price) || 0;
      if (isNaN(price)) price = 0;
      console.log("Setting price:", price);
      const paperButton = document.querySelector(".drawer-button[data-id='papier']");
      if (paperButton) {
        paperButton.dataset.price = price;
      }

      if (!initOptionsProcess) {
        applyOption();

        // Appliquer les mockups de découpe
        if (typeof window.applyCut === "function") {
          window.applyCut();
        }

        // Appliquer la couleur de fond du papier
        if (typeof window.applyPaperBackground === "function") {
          setTimeout(() => window.applyPaperBackground(), 500);
        }
      }
    });
  });
  }

  /**
   * Event listener for enveloppe selection
   */
  let selectEnveloppe = document.querySelector(
    "product-drawer-enveloppe .drawer--list"
  );
  if (selectEnveloppe) selectEnveloppe.querySelectorAll("[data-value]").forEach((elem) => {
    elem.addEventListener("click", function (e) {
      selectEnveloppe.querySelectorAll("[data-value]").forEach((elem) => {
        elem.classList.remove("actif");
      });

      let value = elem.dataset.value;
      CONFIGURATOR.current_enveloppe = value;
      elem.classList.add("actif");

      let paper_title = elem.dataset.enveloppeTitle;
      document.querySelector(".enveloppe-value").innerHTML = paper_title;

      let price = parseInt(elem.dataset.price);
      document.querySelector(
        ".drawer-button[data-id='enveloppe']"
      ).dataset.price = price;

      if (!initOptionsProcess) {
        applyOption();
      }
    });
  });

  /**
   * Event listener for ruban selection
   */
  let selectRuban = document.querySelector(
    "product-drawer-ruban .drawer--list"
  );
  if (selectRuban) selectRuban.querySelectorAll("[data-value]").forEach((elem) => {
    elem.addEventListener("click", function (e) {
      selectRuban.querySelectorAll("[data-value]").forEach((elem) => {
        elem.classList.remove("actif");
      });

      let value = elem.dataset.value;
      CONFIGURATOR.current_ribbon = value;
      elem.classList.add("actif");

      let paper_title = elem.dataset.rubanTitle;
      document.querySelector(".ruban-value").innerHTML = paper_title;

      let price = parseInt(elem.dataset.price);
      document.querySelector(".drawer-button[data-id='ruban']").dataset.price =
        price;

      if (!initOptionsProcess) {
        applyOption();
      }
    });
  });
}

jQuery(function () {
  // get creation ref on url params "ref_id"
  var urlParams = new URLSearchParams(window.location.search);
  var ref_id = urlParams.get("ref_id");
  CONFIGURATOR.ref_configuration = ref_id;
  if (ref_id) {
    initProductListeners(ref_id);
  } else {
    initProductListeners("");
  }

  // Init default options AFTER initProductListeners has attached all event listeners
  waitForDrawersAndInit(20);
});

/***
 * Get mockup preview functions
 */

async function getMockupPreview(
  data,
  type = "DynamicPreviewMockups",
  nb_previews = nb_client_mockups_preview,
  data_preview_black = null
) {
  let images_result = [];

  document.querySelector(".loader__container").classList.add("visible");
  document.querySelector("media-gallery").classList.add("opacity");

  let pages = {
    pages: [],
  };

  console.log(data);

  for (var i = 0; i < nb_previews; i++) {
    var data2 = {
      template: `PreviewMockups/${p_obj.PreviewMockup}/${type}/${
        configJson.format.ref
      }/PREVIEW_P${i + 1}.psd`,
      format: "jpg",
      data: {},
    };

    if (type === "DynamicPreviewMockups") {
      data2["size"] = {
        width: 1000,
        height: 1000,
      };
    } else {
      data2["size"] = {
        width: 1000,
        height: 1000,
      };
    }

    for (let j = 0; j < configJson.format.ref_pages.length; j++) {
      if (data == null) {
        for (var k = 0; k < p_obj.design_layer_preview_mockup.length; k++) {
          data2.data[`${p_obj.design_layer_preview_mockup[k]}_P${j + 1}`] = {
            type: "switch",
            select: `CUT${CONFIGURATOR.current_cut}`,
          };

          let quadri_3dfoil_pages = null;
          let varnish_quadri_pages = null;

          if (p_obj.ref_profil.toUpperCase() == "QUADRI3DFOIL" || p_obj.ref_profil.toUpperCase() == "3DFOIL") {
            quadri_3dfoil_pages =
              configJson.format["3d_foil_quadri_pages"].split(",");
            quadri_3dfoil_pages = quadri_3dfoil_pages.map(
              (item) => parseInt(item) - 1
            );
          }

          if (p_obj.ref_profil.toUpperCase() == "QUADRI3DVARNISH") {
            varnish_quadri_pages =
              configJson.format["varnish_quadri_pages"].split(",");
            varnish_quadri_pages = varnish_quadri_pages.map(
              (item) => parseInt(item) - 1
            );
          }

          console.log(quadri_3dfoil_pages, j);

          if (
            ((p_obj.design_layer_preview_mockup[k] == "Spot1" &&
              p_obj.ref_profil.toUpperCase() != "WHITE" &&
              p_obj.ref_profil.toUpperCase() != "1COLOR") ||
              p_obj.design_layer_preview_mockup[k] == "SpotSH" ||
              (p_obj.design_layer_preview_mockup[k] == "Spot2" &&
                p_obj.ref_profil.toUpperCase() != "3DVARNISH")) &&
            j > 0
          ) {
            if (
              (p_obj.ref_profil.toUpperCase() == "QUADRI3DFOIL" || p_obj.ref_profil.toUpperCase() == "3DFOIL") &&
              (p_obj.design_layer_preview_mockup[k].toUpperCase() == "SPOT1" ||
                p_obj.design_layer_preview_mockup[k].toUpperCase() ==
                  "SPOTSH") &&
              quadri_3dfoil_pages.includes(j) == false
            ) {
              data2.data[`${p_obj.design_layer_preview_mockup[k]}_P${j + 1}`] =
                {
                  type: "switch",
                  select: `null`,
                };
              continue;
            }

            if (
              p_obj.ref_profil.toUpperCase() == "QUADRI3DVARNISH" &&
              p_obj.design_layer_preview_mockup[k].toUpperCase() == "SPOT2" &&
              varnish_quadri_pages.includes(j) == false
            ) {
              data2.data[`${p_obj.design_layer_preview_mockup[k]}_P${j + 1}`] =
                {
                  type: "switch",
                  select: `null`,
                };
              continue;
            }
          }

          data2.data[
            `${p_obj.design_layer_preview_mockup[k]}_P${j + 1}\\CUT${
              CONFIGURATOR.current_cut
            }`
          ] = {
            type: "image",
            url:
              "ProofsImages/" +
              window.site_id +
              "/" +
              p_obj.ref_profil.toLowerCase() +
              "/" +
              configJson.format.ref +
              "/" +
              configJson.ref_design +
              "_" +
              configJson.format.ref +
              "_" +
              p_obj.design_layer_preview_mockup[k].toUpperCase() +
              (CONFIGURATOR.ref_texture &&
              p_obj.design_layer_preview_mockup[k].toUpperCase() != "SPOTSH" &&
              p_obj.design_layer_preview_mockup[k].toUpperCase() != "MASTER"
                ? "_" + CONFIGURATOR.ref_texture.split(".")[0].toUpperCase()
                : "") +
              "_P" +
              (j + 1) +
              "." +
              p_obj.preview_mockup_file_extension,
            resizeMode: "fill",
          };
        }
        if (
          CONFIGURATOR.current_paper == "350M-PB" &&
          p_obj.ref_profil.toUpperCase() == "QUADRI"
        ) {
          data2.data[`Gloss_P${j + 1}`] = {
            type: "switch",
            select: `CUT${CONFIGURATOR.current_cut}`,
          };
          data2.data[`Gloss_P${j + 1}\\CUT${CONFIGURATOR.current_cut}`] = {
            type: "image",
            url: "ImagesMockups/Effects/Gloss.png",
          };
        } else {
          data2.data[`Gloss_P${j + 1}`] = {
            type: "switch",
            select: `null`,
          };
        }
      } else {
        let image = null;
        if (Array.isArray(data[j])) {
          image = data[j][0];
        } else {
          image = data[j];
        }

        for (var k = 0; k < p_obj.design_layer_preview_mockup.length; k++) {
          console.log(p_obj.design_layer_preview_mockup[k], j);
          data2.data[`${p_obj.design_layer_preview_mockup[k]}_P${j + 1}`] = {
            type: "switch",
            select: `CUT${CONFIGURATOR.current_cut}`,
          };

          let quadri_3dfoil_pages = null;
          let varnish_quadri_pages = null;

          if (p_obj.ref_profil.toUpperCase() == "QUADRI3DFOIL" || p_obj.ref_profil.toUpperCase() == "3DFOIL") {
            quadri_3dfoil_pages =
              configJson.format["3d_foil_quadri_pages"].split(",");
            quadri_3dfoil_pages = quadri_3dfoil_pages.map(
              (item) => parseInt(item) - 1
            );
          }

          if (p_obj.ref_profil.toUpperCase() == "QUADRI3DVARNISH") {
            varnish_quadri_pages =
              configJson.format["varnish_quadri_pages"].split(",");
            varnish_quadri_pages = varnish_quadri_pages.map(
              (item) => parseInt(item) - 1
            );
          }

          console.log(quadri_3dfoil_pages, j);

          if (
            ((p_obj.design_layer_preview_mockup[k] == "Spot1" &&
              p_obj.ref_profil.toUpperCase() != "WHITE" &&
              p_obj.ref_profil.toUpperCase() != "1COLOR") ||
              p_obj.design_layer_preview_mockup[k] == "SpotSH" ||
              (p_obj.design_layer_preview_mockup[k] == "Spot2" &&
                p_obj.ref_profil.toUpperCase() != "3DVARNISH")) &&
            j > 0
          ) {
            if (
              (p_obj.ref_profil.toUpperCase() == "QUADRI3DFOIL" || p_obj.ref_profil.toUpperCase() == "3DFOIL") &&
              (p_obj.design_layer_preview_mockup[k].toUpperCase() == "SPOT1" ||
                p_obj.design_layer_preview_mockup[k].toUpperCase() ==
                  "SPOTSH") &&
              quadri_3dfoil_pages.includes(j) == false
            ) {
              data2.data[`${p_obj.design_layer_preview_mockup[k]}_P${j + 1}`] =
                {
                  type: "switch",
                  select: `null`,
                };
              continue;
            }

            if (
              p_obj.ref_profil.toUpperCase() == "QUADRI3DVARNISH" &&
              p_obj.design_layer_preview_mockup[k].toUpperCase() == "SPOT2" &&
              varnish_quadri_pages.includes(j) == false
            ) {
              data2.data[`${p_obj.design_layer_preview_mockup[k]}_P${j + 1}`] =
                {
                  type: "switch",
                  select: `null`,
                };
              continue;
            }
          }

          data2.data[
            `${p_obj.design_layer_preview_mockup[k]}_P${j + 1}\\CUT${
              CONFIGURATOR.current_cut
            }`
          ] = {
            type: "image",
            url:
              p_obj.design_layer_preview_mockup[k].toUpperCase() != "SPOTSH"
                ? image
                : image,
            resizeMode: "fill",
          };
        }
      }

      if (
        CONFIGURATOR.current_paper == "350M-PB" &&
        p_obj.ref_profil.toUpperCase() == "QUADRI"
      ) {
        data2.data[`Gloss_P${j + 1}`] = {
          type: "switch",
          select: `CUT${CONFIGURATOR.current_cut}`,
        };
        data2.data[`Gloss_P${j + 1}\\CUT${CONFIGURATOR.current_cut}`] = {
          type: "image",
          url: "ImagesMockups/Effects/Gloss.png",
        };
      } else {
        data2.data[`Gloss_P${j + 1}`] = {
          type: "switch",
          select: `null`,
        };
      }

      data2.data[`Paper_P${j + 1}`] = {
        type: "switch",
        select: `CUT${CONFIGURATOR.current_cut}`,
      };

      data2.data[`Paper_P${j + 1}\\CUT${CONFIGURATOR.current_cut}`] = {
        type: "image",
        url: "ImagesMockups/Papers/" + CONFIGURATOR.current_paper + ".jpg",
      };

      data2.data[`Effect_P${j + 1}`] = {
        type: "switch",
        select: `CUT${CONFIGURATOR.current_cut}`,
      };

      data2.data[`Shadow_P${j + 1}`] = {
        type: "switch",
        select: `CUT${CONFIGURATOR.current_cut}`,
      };
    }

    data2.data[`ENVELOPE`] = {
      type: "image",
      url: `ImagesMockups/Envelopes/${CONFIGURATOR.current_enveloppe}.png`,
    };

    data2.data[`RIBBON`] = {
      type: "image",
      url: `ImagesMockups/Ribbons/${configJson.format.ref}/${CONFIGURATOR.current_ribbon}.png`,
    };

    let bgs = configJson.background_preview.split(",");
    console.log(bgs);

    if (configJson.background_preview.length > 0) {
      for (const bg of bgs) {
        data2.data[bg.split(":")[0]] = {
          type: "image",
          url: `ImagesMockups/Background/${bg.split(":")[1]}`,
        };
      }
    }

    pages.pages.push(data2);
  }

  console.log(pages);

  const response = await fetch(
    window.SERVICE_URLS.di + "/api/rendering/multipage/preview?disableCache=false",
    {
      method: "POST",
      headers: { "Content-Type": "application/json; charset=utf-8" },
      body: JSON.stringify(pages),
    }
  );

  const result = await response.json();
  if (response.status === 200) {
    for (let index = 0; index < result.results.length; index++) {
      let imageUrl = result.results[index].url;
      console.log("URL originale de l'API:", imageUrl);

      // Correction pour les URLs malformées de l'API
      imageUrl = imageUrl.replace(
        /customerscanvas\.cigalo\.frapi/g,
        "customerscanvas.cigalo.fr/api"
      );
      imageUrl = imageUrl.replace(
        /(https?:\/\/)?(customerscanvas\.cigalo\.fr|di\.customerscanvas\.cigalo\.fr|customerscanvas\.cigalo)/g,
        window.SERVICE_URLS.diHost
      );

      // Si l'URL commence déjà par https://, on l'utilise telle quelle
      if (imageUrl.startsWith("https://")) {
        images_result.push(imageUrl);
      } else {
        images_result.push("https://" + imageUrl);
      }
      console.log("URL corrigée:", images_result[images_result.length - 1]);
    }

    initMedia(images_result);
  }

  console.log(images_result);

  return images_result;
}

async function removeCut() {
  await editor.getProduct().then(function (product) {
    var mockupsData = product.surfaces.map(function (surface) {
      return { surface: surface };
    });

    product.setMockups(mockupsData, { updateRevertData: false });
  });
  console.log("REMOVE CUT END");
}

async function applyPreviewColor(color, container = "Main") {
  if (color) {
    await editor.getProduct().then(function (product) {
      product.surfaces.forEach((surface) => {
        let containers = surface.getContainers();
        let main = containers.find((item) => item.name == container);
        console.log(main);
        if (main) {
          main.update({
            type: "spotColor",
            previewColor: color,
            outputColor: color,
          });
        }
      });
    });
  }
}

async function applyPreviewTexture(texture) {
  if (texture) {
    const texturePath = `Effects/${texture}${texture.indexOf(".jpg") > -1 ? "" : ".jpg"}`;

    await editor.getProduct().then(function (product) {
      product.surfaces.forEach((surface) => {
        let containers = surface.getContainers();
        let container = p_obj.ref_source.toUpperCase() == "QUADRI3DFOIL" ? "Effects" : "Main";
        let main = containers.find((item) => item.name == container);
        if (main) {
          main.update({
            type: "texture",
            texture: texturePath,
          });
        }
      });
    });
  }
}

/***
 *
 * NEW FUNCTIONS
 */

let first_close = true;

async function applyOption() {
  setTimeout(updateOptionQuantityPrice, 400);

  // Update the price/option labels immediately. initPrice() must run BEFORE the
  // awaited mockup preview below: clicking an option rewrites .decoupe-value /
  // .papier-value (re-inserting a price-conf span hidden by default CSS), and only
  // initPrice re-shows it. Leaving it after `await getMockupPreview()` hides the
  // option price for the whole request — "n'apparaît plus du tout" if it's slow.
  initPrice();

  if (!first_close && !initOptionsProcess) {
    document.querySelector("w-product-template").closeDrawer();
  } else {
    first_close = false;
  }

  if (typeof proofsImages !== "undefined") {
    CONFIGURATOR.proofsImages = proofsImages;
  }

  let view = urlParams.get("step");
  if (view == "configurator_options") {
    if (!("proofsImages" in CONFIGURATOR)) {
      if (_cart_item) {
        CONFIGURATOR.proofsImages = JSON.parse(
          _cart_item.properties["_proofsImages"]
        );
      }
    }

    mockupPreviewsImages = await getMockupPreview(
      CONFIGURATOR.proofsImages,
      "ProofPreviewMockups",
      nb_bonatirer_mockups_preview
    );
    console.log(mockupPreviewsImages);
  } else {
    mockupPreviewsImages = await getMockupPreview(null);
  }

  // CONFIGURATOR.mockupPreviewsImages = mockupPreviewsImages;
  initPrice();

  configJson.options = {
    decoupe: current_cut,
    papier: CONFIGURATOR.current_paper,
    couleur: CONFIGURATOR.current_color,
  };
}

// MOKCUP PREVIEW AND SLIDER

async function initMedia(images_result) {
  // Keep the AI "mise en ambiance" shot(s) in the gallery across EVERY rebuild
  // on the REAL product page — initial load AND every dynamic-image regeneration
  // (paper/cut change), which otherwise drops the AI. Hide it ONLY on the BAT
  // (step=configurator_options): there the customer must see just the mockups.
  // NOTE: "?view=" alone is only a cache-buster added to profil-drawer links on
  // the real page — it must NOT hide the AI shot. Cloned so the caller's array
  // isn't mutated; appended deduped so callers that already include it don't dup.
  images_result = [...images_result];
  const _inConfigurator =
    urlParams.get("step") == "configurator_options";
  if (!_inConfigurator) {
    const _ambianceImgs = (window.product_images_data || [])
      .filter((img) => img.alt && !/_\d/.test(img.alt))
      .map((img) => img.src);
    _ambianceImgs.forEach((a) => {
      if (!images_result.includes(a)) images_result.push(a);
    });
  }

  // check if url params == null
  if (urlParams.get("step") == null) {
    for (let i = 0; i < images_result.length; i++) {
      console.log(i);
      document.querySelector(".media-viewer li:first-child")?.remove();
      document.querySelector(".media-thumbs li:first-child")?.remove();
    }
  }

  let current_videos = document.querySelectorAll(".video-profil");
  let current_videos_thumbs = document.querySelectorAll(".video-profil__thumb");
  document
    .querySelectorAll(".configurator-media.custom-media")
    .forEach((elem) => {
      elem.remove();
    });

  document
    .querySelectorAll(".media-thumbs__configurator.custom-media")
    .forEach((elem) => {
      elem.remove();
    });
  let count = 0;
  console.log(images_result);
  document.querySelector("#product-media").style.display = "flex";

  // reverse images_result array
  images_result = images_result.reverse();

  images_result.forEach((image) => {
    let li = document.createElement("li");
    li.classList.add("custom-media");
    li.classList.add("media-viewer__item", "configurator-media");
    if (count === 0) {
      li.classList.add("is-current-variant");
    }
    let imageToDisplay = document.createElement("div");
    imageToDisplay.classList.add("media", "relative");
    let imageToDisplay2 = document.createElement("img");
    li.setAttribute("data-src", image);
    li.setAttribute("data-fancybox", "gallery");

    imageToDisplay2.src = image;
    imageToDisplay.appendChild(imageToDisplay2);

    li.setAttribute("data-media-id", count);
    li.appendChild(imageToDisplay);
    let thumb = document.createElement("button");
    thumb.classList.add("media-thumbs__btn", "media", "relative", "w-full");
    if (count === 0) {
      thumb.classList.add("is-active");
      thumb.setAttribute("aria-current", true);
    }

    thumb.setAttribute("aria-controls", "gallery-viewer");
    thumb.appendChild(imageToDisplay2.cloneNode(true));

    let li2 = document.createElement("li");
    li2.classList.add("custom-media");
    li2.setAttribute("data-media-id", count);
    li2.classList.add("media-thumbs__item", "media-thumbs__configurator");
    li2.appendChild(thumb);

    document.querySelector(".media-thumbs").prepend(li2);
    imageToDisplay.appendChild(imageToDisplay2);
    document.querySelector("media-gallery").classList.remove("opacity");
    document.querySelector(".media-viewer").prepend(li);
    document.querySelector(".loader__container").classList.remove("visible");
    count++;
  });

  images_result = images_result.reverse();

  console.log(current_videos);
  console.log(current_videos_thumbs);

  current_videos.forEach((video) => {
    document.querySelector(".media-viewer").appendChild(video);
  });

  current_videos_thumbs.forEach((video) => {
    document.querySelector(".media-thumbs").appendChild(video);
  });

  document.querySelector("media-gallery").init();

  Fancybox.bind("[data-fancybox]", {
    // Your custom options
  });

  document.querySelector(".media-thumbs__item:first-child")?.click();
  document.querySelector(".media-thumbs").scrollLeft = 0;
}

// Exposer initMedia globalement pour qu'elle soit accessible depuis w-configurateur.js
window.initMedia = initMedia;

function injectMockupPreviewCookies() {
  applyOption();
}

/***
 * CALCUL PRICE
 */

client_has_selected_qty = false;

function initDefaultOptions() {
  console.log("INIT DEFAULT OPTIONS");
  initOptionsProcess = true;

  // Preserve the cut/paper carried across a profile/format change
  // (w-configurator-drawers.liquid appends them to the URL). Apply each only if
  // the new profile actually offers it; otherwise keep the profile default
  // already in CONFIGURATOR. The existing paper/cut click logic below then
  // selects whatever CONFIGURATOR holds.
  const _carriedCut = urlParams.get("current_cut");
  const _carriedPaper = urlParams.get("current_paper");
  if (
    _carriedCut &&
    document.querySelector(`[data-cut-title][data-value="${_carriedCut}"]`)
  ) {
    CONFIGURATOR.current_cut = _carriedCut;
  }
  if (_carriedPaper) {
    const _pg = document.querySelectorAll("product-drawer-papier [data-profil]");
    const _scoped = [..._pg].some((g) => g.style.display === "none")
      ? [..._pg].find((g) => g.style.display !== "none") || document
      : document;
    if (
      _scoped.querySelector(`[data-paper-title][data-value="${_carriedPaper}"]`)
    ) {
      CONFIGURATOR.current_paper = _carriedPaper;
    }
  }

  // Paper items are rendered once per product profil group; only the active
  // profile's group is shown (the others get display:none on the normal page).
  // Scope the lookup to the visible group so an unscoped query doesn't grab a
  // hidden group's duplicate — WHITE's 300KT is first in the DOM, so it was
  // selected instead of the visible 1COLOR group's 300KT, leaving the drawer
  // with no visible selection. On the options page groups aren't toggled, so
  // keep the original global lookup.
  const _paperGroups = document.querySelectorAll(
    "product-drawer-papier [data-profil]"
  );
  const _paperFiltered = [..._paperGroups].some(
    (g) => g.style.display === "none"
  );
  let _paperEl;
  if (_paperFiltered) {
    const _visibleGroup =
      [..._paperGroups].find((g) => g.style.display !== "none") || document;
    _paperEl =
      _visibleGroup.querySelector(
        `[data-paper-title][data-value="${CONFIGURATOR?.current_paper}"]`
      ) || _visibleGroup.querySelector("[data-paper-title]");
  } else {
    _paperEl = document.querySelector(
      `[data-paper-title][data-value="${CONFIGURATOR?.current_paper}"]`
    );
  }
  _paperEl?.click();
  document
    .querySelector(
      `[data-cut-title][data-value="${CONFIGURATOR?.current_cut}"]`
    )
    ?.click();

  // check view params
  let view = urlParams.get("step");
  const _urlQty = urlParams.get("quantity");
  if (view == "configurator_options") {
    document
      .querySelector(`[data-quantity-value="${CONFIGURATOR.quantity}"]`)
      ?.click();
  } else if (_urlQty) {
    // Product page reloaded after a profile change carries the chosen quantity in
    // the URL. Re-apply it so the total + per-option prices recompute: the server
    // renders the quantity as active, but client_has_selected_qty (set only by the
    // quantity click) stays false on load, so initPrice() early-returns and every
    // price reads "Indisponible" / "à partir de" until the user re-clicks.
    document
      .querySelector(`[data-quantity-value="${_urlQty}"]`)
      ?.click();
  }

  document
    .querySelector(
      `[data-enveloppe-title][data-value="${CONFIGURATOR?.current_enveloppe}"]`
    )
    ?.click();

  document
    .querySelector(
      `[data-ruban-title][data-value="${CONFIGURATOR?.current_ribbon}"]`
    )
    ?.click();

  document
    .querySelectorAll(".drawer-button")
    .forEach((item) => item.classList.remove("loading"));

  setTimeout(() => {
    initOptionsProcess = false;
    const _slug = [CONFIGURATOR.ref_profil, CONFIGURATOR.current_paper, CONFIGURATOR.current_cut]
      .filter(Boolean).join("_").toLowerCase().replace(/[^a-z0-9_-]/g, "");
    // Real render mockups for the current profil/paper/cut. The DI-generation
    // fallback (applyOption) is decided on THESE ONLY — a non-render image must
    // never make the set look "non-empty" and suppress the dynamic-image render
    // (that also leaked the AI shot into the BAT proof). initMedia() re-appends
    // the AI "mise en ambiance" shot itself, so it persists across rebuilds.
    const _renderImgs = (window.product_images_data || [])
      .filter(img => img.alt && img.alt.includes(_slug))
      .map(img => img.src);
    if (urlParams.get("step") == "configurator_options") {
      // On the BAT, do NOT paint the product's default render mockups here — they
      // flash the base design before the customer's saved creation's DI proof is
      // ready. Keep the loader shown; the creation is painted by its own proof
      // generation. (Safety timeout below so the loader never sticks forever.)
      document.querySelector(".loader__container")?.classList.add("visible");
      document.querySelector("media-gallery")?.classList.add("opacity");
      setTimeout(function () {
        document
          .querySelector(".loader__container")
          ?.classList.remove("visible");
        document.querySelector("media-gallery")?.classList.remove("opacity");
      }, 20000);
    } else if (_renderImgs.length > 0) {
      initMedia(_renderImgs);
    } else {
      applyOption();
    }
  }, 100);
  initPrice();
}
document
  .querySelectorAll(".drawer-button")
  .forEach((item) => item.classList.add("loading"));

// Wait for drawer DOM elements to be ready before initializing defaults
let view = urlParams.get("step");
function waitForDrawersAndInit(retries) {
  // Skip entirely for products without configurator drawers (e.g. mug, non-carterie types)
  if (!document.querySelector(".drawer-button")) {
    return;
  }
  const paperReady = document.querySelector('[data-paper-title]');
  const cutReady = document.querySelector('[data-cut-title]');
  // Only require the drawers this product actually has
  const paperOk = paperReady || !document.querySelector("product-drawer-papier");
  const cutOk = cutReady || !document.querySelector("product-drawer-decoupe");
  if ((paperOk && cutOk) || retries <= 0) {
    initDefaultOptions();
  } else {
    setTimeout(() => waitForDrawersAndInit(retries - 1), 300);
  }
}
// waitForDrawersAndInit is called from jQuery ready callback after initProduct()

function initPrice() {
  // check if view == configurator_options
  let view = urlParams.get("step");

  if (!client_has_selected_qty && view != "configurator_options") {
    return;
  }

  if (client_has_selected_qty) {
    document.querySelectorAll(".price-conf").forEach((elem) => {
      if (elem.closest("[data-cut-title]")) {
        elem.setAttribute(
          "style",
          "display: block !important;font-weight: 400"
        );
      } else {
        elem.setAttribute("style", "display: inline !important");
      }
    });
  }

  document.querySelector(".form-price")?.classList.add("hidden");
  let quantity_price = parseInt(
    document.querySelector('[data-id="quantite"]')?.dataset.price
  ) || 0;
  if (isNaN(quantity_price)) quantity_price = 0;
  configJson.quantity_price = quantity_price;

  let quantity = CONFIGURATOR.quantity;
  let Elem = document.querySelector(".price__current");
  let priceElem = document.querySelector(
    ".price__current .price__current__current"
  );
  let priceElemUnit = document.querySelector(
    ".price__current .price__current__unit"
  );

  let options_price = 0;

  document
    .querySelectorAll(
      '.drawer-button:not([data-id="quantite"], [data-id="couleur"])'
    )
    .forEach((elem) => {
      console.log(elem);
      let price = parseInt(elem.dataset.price) || 0;
      if (isNaN(price)) price = 0;
      console.log(price);
      options_price += price * quantity;
      configJson.item_options[elem.dataset.id] = price;
    });
  if (client_has_selected_qty == true) {
    total_price = quantity_price + options_price;

    priceElem.innerHTML =
      "TOTAL " + (total_price / 100).toFixed(2).replace(".", ",") + " €";
    priceElemUnit.innerHTML =
      "(" +
      (total_price / quantity / 100).toFixed(2).replace(".", ",") +
      " € l'unité)";

    Elem.classList.add("visible");
  }
  updateOptionQuantityPrice();
}

function updateOptionQuantityPrice() {
  document.querySelectorAll("[data-option-price-unit]").forEach((elem) => {
    elem.innerHTML =
      (
        (parseInt(elem.dataset.optionPriceUnit) * CONFIGURATOR.quantity) /
        100
      ).toFixed(2).replace('.', ',') + " €";
  });
}

(function () {
  let btn_return = document.querySelector("#ccHistoryBackOptions");
  let view_params = urlParams.get("step");

  btn_return?.addEventListener("click", function () {
    if (view_params === "configurator_options") {
      window.location.href = window.location.href
        .replace("&view", "&cached")
        .replace("step=configurator_options", "view=configurator");
    } else if (view_params === "configurator") {
      window.location.href = window.location.href
        .replace("&view", "&cached")
        .replace("view=configurator", "");
    }
  });
})();

document.addEventListener("DOMContentLoaded", function () {
  if (CONFIGURATOR.quantity && CONFIGURATOR.quantity > 1) {
    setTimeout(() => {
      const quantityItems = document.querySelectorAll(
        ".drawer-list__item--quantity"
      );
      let quantityRestored = false;

      quantityItems.forEach((item) => {
        const itemQuantity = parseInt(item.dataset.quantityValue);
        if (itemQuantity === CONFIGURATOR.quantity) {
          item.classList.add("actif");
          quantityRestored = true;

          const quantityDisplay = document.querySelector(
            '[data-id="quantite"] .quantite-value'
          );
          if (quantityDisplay) {
            quantityDisplay.textContent = item.dataset.quantityLabel;
          }

          const quantityContainer = document.querySelector(
            '[data-id="quantite"]'
          );
          if (quantityContainer) {
            quantityContainer.dataset.price = item.dataset.price;
            quantityContainer.dataset.quantity = item.dataset.quantityValue;
          }

          document
            .querySelectorAll(
              ".decoupe-value, .papier-value, .enveloppe-value, .ruban-value"
            )
            .forEach((elem) => {
              const selector = elem.classList.contains("decoupe-value")
                ? "[data-cut-title].actif"
                : elem.classList.contains("papier-value")
                ? "[data-paper-title].actif"
                : elem.classList.contains("enveloppe-value")
                ? "[data-enveloppe-title].actif"
                : "[data-ruban-title].actif";
              const activeElem = document.querySelector(selector);
              if (activeElem) {
                const dataAttr = elem.classList.contains("decoupe-value")
                  ? "cutTitle"
                  : elem.classList.contains("papier-value")
                  ? "paperTitle"
                  : elem.classList.contains("enveloppe-value")
                  ? "enveloppeTitle"
                  : "rubanTitle";
                elem.innerHTML = activeElem.dataset[dataAttr] || "";
              }
            });
        } else {
          item.classList.remove("actif");
        }
      });

      if (quantityRestored) {
        const priceElements = document.querySelectorAll(".price-conf");
        priceElements.forEach((elem) => {
          if (elem.closest("[data-cut-title]")) {
            elem.setAttribute(
              "style",
              "display: block !important;font-weight: 400"
            );
          } else {
            elem.setAttribute("style", "display: inline !important");
          }
        });

        initPrice();
      }
    }, 500);
  }

  // Fix paper elements: add missing data attributes from paper_metadata
  const fixPaperElements = () => {
    const paperItems = document.querySelectorAll('.drawer-list__item--paper');
    console.log(`🔧 Found ${paperItems.length} paper items to fix`);

    paperItems.forEach(item => {
      const paperValue = item.dataset.value;

      // Check if attributes already exist
      if (item.dataset.paperTitle && item.dataset.price) {
        console.log(`✅ Paper ${paperValue} already has attributes`);
        return;
      }

      // Get paper metadata from window.paper_metadata
      if (window.paper_metadata && window.paper_metadata[paperValue]) {
        const metadata = window.paper_metadata[paperValue];

        // Add data-paper-title
        const priceDisplay = metadata.price === 0 || metadata.price === "0"
          ? "(inclus)"
          : `(+ <span data-option-price-unit='${metadata.price}'>${(metadata.price / 100).toFixed(2).replace('.', ',')}€</span>)`;
        item.dataset.paperTitle = `${metadata.label_client} <span class='price-conf'>${priceDisplay}</span>`;

        // Add data-price
        item.dataset.price = metadata.price;

        console.log(`✅ Fixed paper ${paperValue}:`, metadata.label_client, metadata.price);
      } else {
        console.warn(`⚠️ No metadata found for paper ${paperValue}`);
      }
    });
  };

  // Initialize paper button with first active paper
  const initPaperButton = () => {
    const firstActivePaper = document.querySelector('.drawer-list__item--paper.actif');
    if (firstActivePaper) {
      const paperTitle = firstActivePaper.dataset.paperTitle;
      const paperPrice = firstActivePaper.dataset.price;
      const paperValue = firstActivePaper.dataset.value;

      console.log('🔧 Initializing paper button with:', { paperTitle, paperPrice, paperValue });

      const paperButton = document.querySelector(".drawer-button[data-id='papier']");
      if (paperButton) {
        if (paperTitle) {
          paperButton.dataset.price = paperPrice || 0;
          paperButton.dataset.value = paperValue;
          const paperValueElem = paperButton.querySelector(".papier-value");
          if (paperValueElem) {
            paperValueElem.innerHTML = paperTitle;
          }
          console.log('✅ Paper button initialized successfully');
        } else {
          console.warn('⚠️ First active paper missing data-paper-title attribute');
        }
      } else {
        console.warn('⚠️ Paper button not found');
      }
    } else {
      console.warn('⚠️ No active paper found');
    }
  };

  // Fix paper elements first, then initialize button
  setTimeout(() => {
    fixPaperElements();
    initPaperButton();
  }, 500);
});
